var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.SealNoChangeAdfterInspection"),
        width: "500px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "60px", "label-position": "left" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.ContainerNo") } },
            [
              _c("el-input", {
                attrs: { disabled: true, no: "1" },
                model: {
                  value: _vm.formData.containerNo,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "containerNo", $$v)
                  },
                  expression: "formData.containerNo"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.SealNo") } },
            [
              _c("el-input", {
                attrs: { no: "2" },
                model: {
                  value: _vm.formData.sealNo,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "sealNo", $$v)
                  },
                  expression: "formData.sealNo"
                }
              })
            ],
            1
          ),
          _c("el-form-item", {
            attrs: { label: _vm.$t("SeaExport.AdditionalNotes") }
          }),
          _c(
            "el-form-item",
            { staticClass: "label-none custom" },
            [
              _c("el-input", {
                attrs: { type: "textarea", rows: 5, no: "3" },
                model: {
                  value: _vm.formData.remark,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "remark", $$v)
                  },
                  expression: "formData.remark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary", no: "4" }, on: { click: _vm.onOK } },
            [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "5" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }